import React from 'react';
import CurrencyConverter from './components/CurrencyConverter';
import Header  from './components/header';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import Footer from './components/footer';


const App: React.FC = () => {
  return (
    <div>
      <Header />
      <CurrencyConverter />
      <Footer />
    </div>
  );
};

export default App;

